/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-2016 Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

export default {
  path: '/engage360',
  name: 'advisornet',
  children: [
    // {
    //   path: '/',
    //   name: 'advisornet-index',
    //   load: () => import(/* webpackChunkName: 'advisornet' */ './default'),
    // },
    {
      path: '/',
      name: 'advisornet-index', // 'advisornet-calendar',
      load: () => import(/* webpackChunkName: 'advisornet' */ './calendar'),
    },
    {
      path: '/expenses',
      name: 'advisornet-expenses',
      load: () => import(/* webpackChunkName: 'advisornet' */ './expenses'),
    },
    {
      path: '/expense',
      name: 'advisornet-expense',
      load: () => import(/* webpackChunkName: 'advisornet' */ './expense'),
    },
    {
      path: '/activities',
      name: 'advisornet-activities',
      load: () => import(/* webpackChunkName: 'advisornet' */ './activities'),
    },
    {
      path: '/report',
      name: 'advisornet-report',
      load: () => import(/* webpackChunkName: 'advisornet' */ './report'),
    },
    // {
    //   path: '/leaderboard',
    //   name: 'advisornet-leaderboard',
    //   load: () => import(/* webpackChunkName: 'advisornet' */ './leaderboard'),
    // },
    // {
    //   path: '/ui',
    //   name: 'ui',
    //   load: () => import(/* webpackChunkName: 'advisornet' */ './ui'),
    // },
  ],
  action({ next, store, url }, { siteId }) {
    const state = store.getState();
    const modules =
      (((state.session || {}).USER_DATA || {}).group || {}).modules || [];
    if (!modules.includes('advisornet')) {
      return {
        redirect: `/${siteId}/forbidden?redirect=${encodeURIComponent(
          url || '',
        )}`,
      };
    }
    return next();
  },
};



// WEBPACK FOOTER //
// ./src/routes/client/site/advisornet/index.js